var symphony = symphony || {};

;(function() {

  symphony.givingToolbar = function() {

  	var $body = $('body');

  	if(!$body.hasClass('localSite')){
  		return;
  	}

  	var facebookLink = $('.js-facebookLink').attr('href');
  	var givingToolbar = $('.givingToolbar-toolbar');

  	if(givingToolbar.length <= 0){
  		$('.heroContainer').addClass('no-margin-bottom no-padding-top');
  		if($body.hasClass('events') || $body.hasClass('eventsarticles') || $body.hasClass('story')){
  			$('div[role="main"]').addClass('noGivingToolbar');
  		}
  		return;
  	}

  	$('#emailCapture').find('.facebookLink').attr('href', facebookLink);

	$('.js-emailCapture').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,

		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
	});

	$('.js-modalClose').on('click', function(){
		$.magnificPopup.close();
	});

	$('.js-volunteerSubmit').on('click', function(){
		$('body').append('<form method="post" class="u-hidden" action="https://volunteer.usawest.org/Home.aspx" id="volunteerForm"><input type="text" name="Zip1" value="' + siteAddress.zip + '" placeholder="Enter city, state or zip"><button type="submit" class="btn btn-danger btn-large" id="search" name="search">GO!</button></form>');
		$('#volunteerForm').submit();
	});

  };


})();